// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React from 'react'
import PropTypes from 'prop-types'
import { Query, Mutation } from 'react-apollo'

import {
  Spinner,
  Warning,
  EmployerAPIAccess,
  EmployerAPIAccessTable
} from '../../'

import { QUERY_EMPLOYERS } from '../../../queries'
import {
  MUTATION_IDENTITY,
  MUTATION_CONTACT,
  MUTATION_USER,
  MUTATION_IDENTITY_DELETE
} from '../../../mutations'

import { decodeBase64 } from '../../../utils'


// NOTE: for now this component specifically addresses the requirements of the SMS API,
// but this component and the created User record can be adapted and generalised to facilitate
// wider API type requirements
export class SMSAPIAccessManager extends React.Component {
  static propTypes = {
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  changeAccess = (allowAccess, employerId, identityMutate, contactMutate, userMutate, identityId, identityDelete, refreshEmployerData) => {
    // create or delete identity
    if (allowAccess) {
      identityMutate({
        variables: {
          input: {
            firstName: 'SMS',
            lastName: 'API'
          }
        }
      })
      .then(({ data }) => {
        return contactMutate({
          variables: {
            input: {
              identity: data.identityMutate.identity.id,
              employer: employerId
            }
          }
        })
        .then(() => {
          console.info('SMS API contact created')
          return data.identityMutate.identity
        })
        .catch(() => console.error('Failed to create SMS API contact'))
      })
      .then((identity) => {
        userMutate({
          variables: {
            input: {
              id: identity.user.id,
              smsApiPassword: decodeBase64(employerId)
            }
          }
        })
        .then(() => {
          console.info('SMS API password set')
          refreshEmployerData()
        })
        .catch(() => console.error('Failed to set SMS API password set'))
      })
      .catch(() => console.error('Failed to create SMS API identity'))
    } else {
      identityDelete({
        variables: {
          input: {
            id: identityId
          }
        }
      })
      .then(({ data }) => {
        if (data.identityDelete.outcome) {
          console.info('SMS API identity and corresponding user record deleted')
          refreshEmployerData()
        } else {
          console.info('SMS API identity deletion not possible since invalid id was provided')
        }
      })
      .catch(error => console.error('Failed to delete SMS API identity', error))

    }
  }

  render() {
    const { className } = this.props

    return (
      <Query query={QUERY_EMPLOYERS}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Spinner size='x-small' className='slds-is-relative' />
          }

          if (error) {
            return <Warning>Failed to fetch employer data</Warning>
          }

          const employerAccessById = data.employers.edges.reduce(
            (accumulator, employer) => (
              accumulator[employer.node.id] = {
                name: employer.node.friendlyName,
                access: null,
                key: employer.node.smsApiKey
              }, accumulator
            ),
            {}  // initial value
          )

          return (
            <Mutation mutation={MUTATION_IDENTITY}>
              {(identityMutate, { data }) => (
                <Mutation mutation={MUTATION_IDENTITY_DELETE}>
                  {(identityDelete, { data }) => (
                    <Mutation mutation={MUTATION_CONTACT}>
                      {(contactMutate, { data }) => (
                        <Mutation mutation={MUTATION_USER}>
                          {(userMutate, { data }) => {
                            Object.keys(employerAccessById).forEach(id => (
                              employerAccessById[id].access = <EmployerAPIAccess
                                api='sms'
                                employerId={id}
                                onChange={(allowAccess, identityId, refreshEmployerData) => (
                                  this.changeAccess(
                                    allowAccess,
                                    id,
                                    identityMutate,
                                    contactMutate,
                                    userMutate,
                                    identityId,
                                    identityDelete,
                                    refreshEmployerData
                                  )
                                )}
                              />
                            ))

                            return (
                              <EmployerAPIAccessTable
                                api='sms'
                                employerAccessById={employerAccessById}
                                className={className}
                              />
                            )
                          }}
                        </Mutation>
                      )}
                    </Mutation>
                  )}
                </Mutation>
              )}
            </Mutation>
          )
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/sms-api-access-manager/index.js